import api from "api"

export async function loadHouseholdScenarios(store, household_id) {
  const scenarios = await api.get(`households/${household_id}/scenarios`)
  await store.update(state => {
    state.householdScenarioIds[household_id] = scenarios.map(
      scenario => scenario.id
    )

    scenarios.forEach(scenario => {
      state.scenarios[scenario.id] = scenario
    })
  })
}

export async function loadScenario(store, scenario_id) {
  const scenario = await api.get(`scenarios/${scenario_id}`)
  await store.update(state => {
    state.scenarios[scenario.id] = scenario
  })
}

export async function updateScenario(store, { id, ...values }) {
  const scenario = await api.patch(`scenarios/${id}`, undefined, values)
  await store.update(state => {
    state.scenarios[scenario.id] = scenario
  })
}

export async function createScenario(store, { household_id, ...values }) {
  const scenario = await api.post(
    `households/${household_id}/scenarios`,
    {},
    values
  )

  await store.update(state => {
    state.householdScenarioIds[household_id].push(scenario.id)
  })
  // FIXME: Shouldn't be here
  await store.actions.updateHouseholdState({
    id: household_id,
    currentScenarioId: scenario.id
  })
}

export async function deleteScenario(store, { household_id, scenario_id }) {
  await api.delete(`scenarios/${scenario_id}`)

  await store.update(state => {
    state.householdScenarioIds[household_id].splice(
      state.householdScenarioIds[household_id].findIndex(
        id => id === scenario_id
      ),
      1
    )
    delete state.scenarios[scenario_id]
  })
}

export async function getScenarioCase(store, scenario_id) {
  const scenarioCase = await api.get(`scenarios/${scenario_id}/case`)
  return scenarioCase
}
